import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import "./GetStartedPage.css";
import getstartedimg from "../img/getstarted.png";
import { Link } from "react-router-dom";

const GetStartedPage = () => {
  return (
    <div className="gs-page">
      <div className="gs-bg-glow gs-bg-glow-1"></div>
      <div className="gs-bg-glow gs-bg-glow-2"></div>

      <Container fluid="xl" className="gs-container">
        <div className="gs-badge">Welcome to Revexia</div>

        <Row className="align-items-center gs-hero-row">
          <Col xl={5} lg={5} className="gs-left">
            <div className="gs-content-wrap">
              <h1 className="gs-title">
                Convert Social Media Audience
                <br />
                Into Customers
              </h1>

              <h2 className="gs-subtitle">
                Revexia Turns Every Social DM Into
                <br />
                Revenue — Automatically
              </h2>

              <p className="gs-description">
                Connect your social media, ManyChat, and Shopify to start
                detecting high-intent buyers, personalizing offers, and
                attributing every sale back to the DM that started it.
              </p>

              <div className="gs-conversion-block">
                <p className="gs-conversion-text">
                  Your DM-to-checkout
                  <br />
                  conversion
                </p>
              </div>
            </div>
          </Col>

          <Col xl={7} lg={7} className="gs-right">
            <div className="gs-preview-wrap">
              <div className="gs-action-wrap">
                <Link to="/dm-activity" className="gs-connect-btn">Connect Platforms</Link>
              </div>

              <div className="gs-image-shell">
                <div className="gs-image-frame">
                  <img
                    src={getstartedimg}
                    alt="Revexia platform preview"
                    className="gs-preview-image"
                  />
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default GetStartedPage;